import { oneWay } from '@ember/object/computed';
import BaseDeliveryRoute from 'cio/routes/base-delivery';
import isDestroyed from 'cio/utils/is-destroyed';

export default class DraftRoute extends BaseDeliveryRoute {
  crumb() {
    let draft = this.modelFor('draft');

    return {
      name: oneWay('model.detail.subject'),
      path: 'draft',
      model: draft,
    };
  }

  deactivate() {
    super.deactivate(...arguments);

    let draft = this.modelFor('draft');

    if (isDestroyed(draft)) {
      // can happen in tests
      return;
    }

    draft.get('detail').then((detail) => detail.rollbackAttributes());
  }
}
